import React from 'react'

import LoadingSection from 'components_new/molecules/LoadingSection'

import { useWidgetLoadingTitles } from 'utils/loadingTitles'

import { TCoreWidget, WidgetType } from 'types/GlobalWidget'

interface LoadingProps {
  scaleFactor: number
  widget: TCoreWidget
}

const Loading = (props: LoadingProps) => {
  const { scaleFactor, widget } = props

  const loadingTitles = useWidgetLoadingTitles()

  if (
    widget.type !== WidgetType.TEXT &&
    widget.type !== WidgetType.COMMENT &&
    widget.type !== WidgetType.IMAGE
  ) {
    return (
      <LoadingSection description={loadingTitles} scaleFactor={scaleFactor} />
    )
  }

  return null
}

export default Loading
